'use client';

import {
  Button,
  InfoCard,
  Input,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Label
} from '@goodneighbor/ui';
import styles from './form.module.scss';
import authStyles from './auth.module.scss';
import NextLink from 'next/link';

import useAuthHooks from '@/hooks/useAuthHooks';
import { getLoginErrorMessage } from '@/services/errors';
import MfaLoginModal from '@/components/modals/MfaLoginModal';

export default function Login() {
  const {
    signInForm,
    onSignInSubmit,
    signInMutation,
    mfaLoginState,
    verifyMfaLoginMutation,
    resendMfaLoginMutation,
    handleMfaCancel
  } = useAuthHooks();

  return (
    <>
      {mfaLoginState && (
        <MfaLoginModal
          mfaLoginState={mfaLoginState}
          verifyMfaLoginMutation={verifyMfaLoginMutation}
          resendMfaLoginMutation={resendMfaLoginMutation}
          onCancel={handleMfaCancel}
        />
      )}
      <Form {...signInForm}>
        <form
          method="post"
          className={authStyles.form}
          onSubmit={signInForm.handleSubmit(onSignInSubmit)}
        >
          <FormField
            control={signInForm.control}
            name="phoneOrEmail"
            render={({ field }) => (
              <FormItem className={authStyles.textField}>
                <Label className={styles.label}>Email</Label>
                <FormControl>
                  <Input
                    {...field}
                    placeholder="Enter your email"
                    type="email"
                    hideIcon
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={signInForm.control}
            name="password"
            render={({ field }) => (
              <FormItem className={authStyles.textField}>
                <Label className={styles.label}>Password</Label>
                <FormControl>
                  <Input
                    {...field}
                    type="password"
                    hideIcon
                    placeholder="••••••••"
                    showPasswordToggle
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className={styles.actionsRow}>
            {/* TODO: Add remember me post v1 */}
            {/* <div className={styles.rememberMe}>
            <Checkbox id="remember" />
            <Label htmlFor="remember" className={styles.rememberLabel}>
              Remember for 30 days
            </Label>
          </div> */}
            <NextLink
              href="/volunteer/forgot-password"
              className={styles.forgotLink}
            >
              Forgot password
            </NextLink>
          </div>
          <Button
            className={authStyles.submitButton}
            type="submit"
            size="lg"
            isLoading={signInMutation.isPending}
          >
            Sign in
          </Button>
          {signInMutation.isError && (
            <InfoCard className={authStyles.infoCard} severity="error">
              {getLoginErrorMessage(signInMutation.error)}
            </InfoCard>
          )}
        </form>
      </Form>
    </>
  );
}
